export const INIT = 'init'
export const UNPAID = 'unpaid'
export const UNDELIVERED = 'undelivered'
export const CANCELED = 'canceled'
export const DELIVERING = 'delivering'
export const DELIVERED = 'delivered'
export const COMPLETED = 'completed'
export const RETURNING = 'returning'
export const RETURNED = 'returned'
